import { render, staticRenderFns } from "./EditNotificationConfigDialog.vue?vue&type=template&id=78c17e13&"
import script from "./EditNotificationConfigDialog.vue?vue&type=script&lang=js&"
export * from "./EditNotificationConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports